import { gql } from "@apollo/client";

export const READ_NOTIFICATIONS = gql`
  mutation updateNotificationViewer($viewer: ID!, $viewerPlatform: ID!, $platform: EPlatform!) {
    updateNotificationViewer(viewer: $viewer, viewerPlatform: $viewerPlatform, platform: $platform) {
      error
      message
      code
    }
  }
`;
